import { withSvgIcon } from './withSvgIcon';

export const CircleCheck = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.3583 8.391L17.8952 7.54734L16.2079 6.47359L15.671 7.31725L10.7963 14.9774L7.75725 12.5462L6.97638 11.9215L5.72699 13.4832L6.50786 14.1079L10.4171 17.2353C10.6388 17.4127 10.9255 17.4874 11.2057 17.4409C11.4858 17.3943 11.733 17.2309 11.8854 16.9913L17.3583 8.391Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
